import { Component } from '@angular/core';

@Component({
  selector: 'app-sidebar-minimizer',
  templateUrl: './app-sidebar-minimizer.component.html'
})
export class AppSidebarMinimizerComponent { }



// WEBPACK FOOTER //
// C:/repos/Tulaima/Tulaima-ng/src/app/components/app-sidebar-minimizer/app-sidebar-minimizer.component.ts